module.exports = __webpack_public_path__ + "img/icon_button_save.28388c7.svg";